import { createSelector } from "@reduxjs/toolkit";
import { selectVisibleFacets } from "./select-visible-facets";
import { selectInitialFacets } from "./select-initial-facets";

export const selectVisibleRangeFacetValue = (facetFieldName: string) =>
	createSelector(
		[selectInitialFacets, selectVisibleFacets],
		(initialFacets) => {
			return initialFacets[facetFieldName];
		},
	);
